"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUTCtoZonedTime = transformUTCtoZonedTime;
const utcToZonedTimeOrDefault_1 = require("../helpers/utcToZonedTimeOrDefault");
function transformUTCtoZonedTime(time, timeZone) {
    const zoned = (0, utcToZonedTimeOrDefault_1.utcToZonedTimeOrDefault)(new Date(time), timeZone);
    return zoned;
}
//# sourceMappingURL=transformUTCtoZonedTime.js.map